export default "__VITE_ASSET__BK0_5h8u__"